export function timestampToString(ts: number | string) {
  return dateToString(new Date(ts));
}

export function dateToString(date: Date) {
  function pad(num: number) {
    return num.toString().padStart(2, "0");
  }

  const now = new Date();
  const originDate = new Date(date);

  const originYear = originDate.getFullYear();
  const originDay = `${originDate.getMonth() + 1}/${originDate.getDate()}`;
  const originTime = `${pad(originDate.getHours())}:${pad(originDate.getMinutes())}`;

  if (now.getFullYear() !== originDate.getFullYear()) {
    return `${originYear} ${originDay} ${originTime}`;
  }

  if (now.getDate() === originDate.getDate()) {
    return originTime;
  }

  return `${originDay} ${originTime}`;
}
